import { render, staticRenderFns } from "./mappingTable.vue?vue&type=template&id=55040f61&scoped=true"
import script from "./mappingTable.vue?vue&type=script&lang=js"
export * from "./mappingTable.vue?vue&type=script&lang=js"
import style0 from "./mappingTable.vue?vue&type=style&index=0&id=55040f61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55040f61",
  null
  
)

export default component.exports